// Third-party script loader
(function() {
  'use strict';
  // third-party-loader.js — external loader removed
})();